import React, {Fragment} from "react"
import {get} from "lodash"

import {H2} from "@irati/ui/src/Typography"
import {connect} from "@irati/store"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import Link from "@irati/ui/src/Link"
import id from "@irati/utils/id"
import Flex from "@irati/ui/src/Flex"
import {walletTracking} from "@irati-tracking/wallet"
import Wallet from "../../images/wallet_badge.svg"
import {IntroText} from "../IntroText"
import Image from "../styled/Image"

const handleFaqsClick = () => {
  walletTracking.clickFaqs()
}

interface Props extends InjectIntl {
  isPhone?: boolean
}

const CashIntro: React.FC<Props> = (props) => {
  const {isPhone, formatMessage} = props
  const idNamespace = id("intro", props)

  return (
    <>
      <Flex id={id("header", idNamespace)} alignItems="center">
        <Image src={Wallet} alt="" />
        <H2>
          <FormattedMessage id="wallet.intro.header" />
        </H2>
      </Flex>
      {!isPhone && (
        <Fragment>
          <IntroText message="wallet.intro.description" />
          <Link
            onClick={handleFaqsClick}
            id={id("faq-link", idNamespace)}
            href={formatMessage({id: "wallet.intro.faq.link.href"})}
            target="_blank">
            <FormattedMessage id="wallet.intro.faq.link.text" />
          </Link>
        </Fragment>
      )}
    </>
  )
}

const mapStateToProps = ({mq}) => ({
  isPhone: get(mq, "lessThan.medium", false)
})

export default injectIntl(connect(mapStateToProps)(CashIntro))
